import { render } from "./assessCommonApproval.vue?vue&type=template&id=ee7c415e&scoped=true"
import script from "./assessCommonApproval.vue?vue&type=script&lang=js"
export * from "./assessCommonApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7c415e"]])

export default __exports__